import React from "react";
import ActionEditorLink, { IAction } from "../action-editor/ActionEditor";
import { IUIPropertyDefinition } from "../common";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyGroupTitle, PropertyTitle } from "./common";


export function ClickProperty(title: string, defaultAction: IAction): IUIPropertyDefinition<IAction> {
    return {
        defaults: defaultAction,
        render: (props, uxpContext, contextData, containerId) => {

            return <PropertyContainer>

                <PropertyGroup>
                    <PropertyGroupTitle>{title || 'On Click'}</PropertyGroupTitle>

                    <Property>
                        <PropertyTitle>Action</PropertyTitle>

                        <ActionEditorLink
                            uiProps={props.parentUIProps}
                            designer={props.designer}
                            uxpContext={uxpContext}
                            action={props.uiProps}
                            onChange={s => {
                                props.onChange(s)
                            }}
                            contextData={contextData}
                        />
                    </Property>

                </PropertyGroup>

            </PropertyContainer>
        }
    }
}
